import React from 'react';
import proptypes from 'prop-types';
import { ProjectsOverview } from '@thd-olt-component-react/projects-overview';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';

const { string } = proptypes;

export const ProjectsCard = ({ componentId = '' }) => (
  <ErrorBoundary name="dashboard-snapshot-projects">
    <ProjectsOverview componentId={componentId} isDashboardSnapshot fillHeight />
  </ErrorBoundary>
);

ProjectsCard.propTypes = {
  componentId: string,
};

ProjectsCard.displayName = 'ProjectsCard';
ProjectsCard.dataModel = ProjectsOverview.dataModel;
